import React, { Component } from 'react'
import Alert from './Alert'
import './Alert.scss'

class AlertDanger extends Component {
  render () {
    const { className } = this.props
    return (
      <Alert className={className} bsStyle="danger">
        {this.props.children}
      </Alert>
    )
  }
}

export default AlertDanger
